/**
 * Pages legales : mentions legales, confidentialite, conditions d'utilisation.
 *
 * Le texte vient de `legal/`, pas des catalogues de traduction : ce sont des
 * documents structures et longs, pas des libelles d'interface. Cet ecran ne
 * fait que les mettre en page.
 */
import type { ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { useUiStore } from '../store/uiStore.js';
import { legalDocument, type Block, type LegalKind } from '../legal/index.js';
import { navigate } from '../router.js';
import { Screen } from '../ui/Screen.js';

function renderBlock(block: Block, index: number): ReactElement {
  if (typeof block === 'string') {
    return (
      <p className="legal__body" key={index}>
        {block}
      </p>
    );
  }
  return (
    <ul className="legal__list" key={index}>
      {block.list.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export function LegalScreen({ kind }: { kind: LegalKind }): ReactElement {
  const t = useT();
  const language = useUiStore((state) => state.language);

  const document = legalDocument(language, kind);

  return (
    <Screen name={`legal-${kind}`} scroll>
      <main className="legal">
        <h1 className="legal__title">{document.title}</h1>
        <p className="legal__updated">{document.updated}</p>

        {document.sections.map((section) => (
          <section className="legal__section" key={section.heading}>
            <h2 className="legal__heading">{section.heading}</h2>
            {section.blocks.map(renderBlock)}
          </section>
        ))}

        <div className="legal__actions">
          <button type="button" className="button-primary" onClick={() => navigate('/')}>
            {t('common.back')}
          </button>
        </div>
      </main>
    </Screen>
  );
}
